import BaseSubscription from './BaseSubscription';
import { fragmentMessageFull, serializeMessageFull } from './serializers';
import services, { logInfo, logError } from './services';
import { gql, insertGraphQLFragments } from './GraphQLClient';


export const UPDATE_MESSAGES_SUBSCRIBE_SUCCESS = 'UPDATE_MESSAGES_SUBSCRIBE_SUCCESS';
export const UPDATE_MESSAGES_SUBSCRIBE_ERROR = 'UPDATE_MESSAGES_SUBSCRIBE_ERROR';
export const UPDATE_MESSAGES_CHANGE = 'UPDATE_MESSAGES_CHANGE';


export default class UpdateMessageSubscription extends BaseSubscription {

  roomId = null;

  updateMessageQuery = insertGraphQLFragments(gql`
    subscription ($roomId: ID!) {
      updateMessage(roomId: $roomId) {
        ...fragmentMessageFull
      }
    }
  `, { fragmentMessageFull });

  subscribeToRoom = (roomId, callback) => {
    this.roomId = roomId;

    return services.graphQLClientSocket.subscribe({
      query: this.updateMessageQuery,
      variables: {
        roomId: this.roomId
      },
      onAbort: error => {
        logError('UpdateMessageSubscription: Failed to subscribe', { error });
        this.triggerEvent(UPDATE_MESSAGES_SUBSCRIBE_ERROR, { error });
      },
      onStart: () => {
        logInfo('UpdateMessageSubscription: Subscribed');
        this.triggerEvent(UPDATE_MESSAGES_SUBSCRIBE_SUCCESS);
        callback && callback();
      },
      onResult: response => {
        const data = response?.data?.updateMessage;
        if (!data) {
          return;
        }
        const message = serializeMessageFull(data);
        this.triggerEvent(UPDATE_MESSAGES_CHANGE, message);
      },
    });
  };

  unsubscribeFromCurrentRoom = () => {
    logInfo('UpdateMessageSubscription: Unsubscribing...');
    services.graphQLClientSocket.unsubscribe(this.updateMessageQuery);
    this.roomId = null;
  };
}
